<!-- Delete Confirmation Dialog-->
<ui-dialog
    [open]="isDeleteInterviewConfirmationDialog"
    (closing)="closeDeleteInterviewConfirmationDialog()"
    [header]="{ key: 'applicant-tracker.deleteInterviewName', params: { interviewName: interview.name } }"
    primaryButtonLabel="{{ 'delete' | translate }}"
    primaryButtonType="danger"
    (primaryButtonPressed)="onDelete()"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    secondaryButtonType="ghost"
    (secondaryButtonPressed)="closeDeleteInterviewConfirmationDialog()"
    size="small"
>
    <div>
        {{
            'applicant-tracker.messages.interview.anyInformationRelatedToInterviewNameInterviewGuideWill'
                | translate: { name: interview.name }
        }}
        <div class="margin-top-2">
            {{ 'applicant-tracker.messages.interview.areYouSureYouWantToDelete' | translate }}
        </div>
    </div>
</ui-dialog>

<div *ngIf="interview" class="ui basic segment" [class.loading]="isLoading">
    <app-header [back]="true" contextMenuType="material" [contextMenu]="true" [title]="interview.name">
        <button (click)="editInterview()" mat-menu-item>{{ 'edit' | translate }}</button>
        <button (click)="openDeleteInterviewConfirmationDialog()" mat-menu-item>{{ 'delete' | translate }}</button>
    </app-header>

    <div class="app-grid">
        <div class="columns-3">
            <ui-card>
                <app-segment-header title="applicant-tracker.details"></app-segment-header>
                <div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.jobPosting' | translate }}</div>
                        <div class="value">{{ interview.jobPosting?.title }}</div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.lastModifiedBy' | translate }}</div>
                        <div class="value">
                            {{
                                'applicant-tracker.modifiedByNameOnDate'
                                    | translate
                                        : {
                                              name: interview.updatedBy?.fullName,
                                              date: interview.createdAt | appDate: 'longDate',
                                          }
                            }}
                        </div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.dateCreated' | translate }}</div>
                        <div class="value">{{ interview.createdAt | appDate: 'longDate' }}</div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.description' | translate }}</div>
                        <div class="value margin-top-1">{{ interview.description }}</div>
                    </div>
                </div>
            </ui-card>
        </div>
        <div class="columns-9">
            <ui-card>
                <app-segment-header title="applicant-tracker.questions"></app-segment-header>
                <hr class="margin-bottom-4" />
                <app-job-posting-interview-questions-preview
                    [interviewQuestions]="interview.interviewQuestions"
                    [isSecondaryVariant]="true"
                ></app-job-posting-interview-questions-preview>
            </ui-card>
        </div>
    </div>
</div>
